import { DriverRanking } from '../../models/client-ranking';

export type DriverSortColumn = 'motorLoadPercentage' | 'inertiaPercentage';
export type DriverSortDirection = 'asc' | 'desc';

export function sortDrivers(
  drivers: DriverRanking[],
  column: DriverSortColumn,
  direction: DriverSortDirection
): DriverRanking[] {
  const sorted = [...drivers].sort((a, b) => {
    // Carga 0 = sem dado útil — sempre no fim (mesma regra do DashboardDriversMapper na API)
    if (column === 'motorLoadPercentage') {
      const aMissing = a.motorLoadPercentage <= 0;
      const bMissing = b.motorLoadPercentage <= 0;
      if (aMissing !== bMissing) return aMissing ? 1 : -1;
    }

    const av = a[column];
    const bv = b[column];
    if (av === bv) return 0;
    const cmp = av < bv ? -1 : 1;
    return direction === 'desc' ? -cmp : cmp;
  });
  return sorted.map((d, i) => ({ ...d, position: i + 1 }));
}

/** Default: carga asc (menor % = melhor). */
export function defaultDriverSort(
  drivers: DriverRanking[]
): { rows: DriverRanking[]; column: DriverSortColumn; direction: DriverSortDirection } {
  return {
    rows: sortDrivers(drivers, 'motorLoadPercentage', 'asc'),
    column: 'motorLoadPercentage',
    direction: 'asc',
  };
}

export function toggleSort(
  currentColumn: DriverSortColumn,
  currentDirection: DriverSortDirection,
  clicked: DriverSortColumn
): { column: DriverSortColumn; direction: DriverSortDirection } {
  if (clicked === currentColumn) {
    return {
      column: currentColumn,
      direction: currentDirection === 'asc' ? 'desc' : 'asc',
    };
  }
  // Nova coluna: carga → asc (melhor primeiro); inércia → desc (maior % melhor)
  return {
    column: clicked,
    direction: clicked === 'motorLoadPercentage' ? 'asc' : 'desc',
  };
}
